import { createSelector } from 'reselect';
import { persistFiltersOnBrandSelector } from 'selectors/testTarget/offers/persistFiltersOnBrand/persistFiltersOnBrandSelector';

const enabledSelector = createSelector(persistFiltersOnBrandSelector, persistFiltersOnBrand => !!persistFiltersOnBrand.enabled);

export { enabledSelector };
